<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../../../../configs/text';
import { useQuizStore, useSignalRStore } from '../../../../../stores';

import ButtonV2 from '../../../../General/ButtonV2.vue';
import Modal from '../../../../General/Modal.vue';
import Heading from '../../../../General/Heading.vue';
import QuizInfomation from './QuizInfomation.vue';

const { t } = useI18n()
const quizStore = useQuizStore();
const signalr = useSignalRStore()
const modalShow = ref<boolean>(false)

function applySetting() {
    signalr.quizSetting()
    modalShow.value = false
}

</script>

<template>
    <ButtonV2 color="danger" class="w-full" animation @click="modalShow = true">{{ t(TEXT.settings) }}</ButtonV2>
    <Modal v-model="modalShow" :close-btn="false" :transparent="true" static>
        <div class="flex flex-col items-center border-2 border-yellow-500 dark:border-fuchsia-500 bg-white dark:bg-slate-800 text-indigo-950 dark:text-white rounded-3xl overflow-hidden"
            :data-mode="quizStore.darkMode ? 'dark' : 'light'">
            <Heading class="w-full text-center text-white !text-3xl font-bold bg-yellow-400 dark:bg-fuchsia-500 py-3 px-14 relative">
                <p class="capitalize">{{ t(TEXT.settings) }}</p>
                <div
                    class="absolute top-1/2 -translate-y-1/2 right-3 border-2 border-white bg-white dark:bg-fuchsia-500 rounded-xl h-fit w-fit">
                    <ButtonV2 type="icon" color="warning" class="p-2 dark:bg-fuchsia-500 dark:shadow-fuchsia-700 dark:border-fuchsia-700" @click="modalShow = false"
                        @touchend="modalShow = false">
                        <svg width="20" height="20" viewBox="0 0 25 25" fill="currentColor"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M17.0397 12.8086L23.2698 6.57859C24.5898 5.25859 24.5898 3.11859 23.2698 1.79859C21.9498 0.478594 19.8098 0.478594 18.4898 1.79859L12.2598 8.0286L6.02973 1.79859C4.70973 0.478594 2.56977 0.478594 1.24977 1.79859C-0.0702344 3.11859 -0.0702344 5.25859 1.24977 6.57859L7.47975 12.8086L1.24977 19.0386C-0.0702344 20.3586 -0.0702344 22.4986 1.24977 23.8186C2.56977 25.1386 4.70973 25.1386 6.02973 23.8186L12.2598 17.5886L18.4898 23.8186C19.8098 25.1386 21.9498 25.1386 23.2698 23.8186C24.5898 22.4986 24.5898 20.3586 23.2698 19.0386L17.0397 12.8086Z" />
                        </svg>
                    </ButtonV2>
                    
                </div>
            </Heading>

            <div class="w-full flex flex-col items-center p-3">
                <QuizInfomation>
                    <template v-slot:settings>
                        <tr>
                            <td class="font-bold p-2 first-letter:uppercase"><label>{{ `${t(TEXT.show_correct_answer_toggle)}:` }}</label>
                            </td>
                            <td class="p-2 flex items-center">
                                <label class="inline-flex items-center cursor-pointer">
                                    <input type="checkbox" class="sr-only peer" :true-value="1" :false-value="0"
                                        v-model="quizStore.quizSetting.showCorrectAnswer">
                                    <div
                                        class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 dark:peer-focus:ring-fuchsia-400 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-fuchsia-700 peer-checked:bg-blue-500 dark:peer-checked:bg-fuchsia-500">
                                    </div>
                                </label>
                            </td>
                        </tr>
                    </template>
                </QuizInfomation>
            </div>

            <div class="w-full flex justify-center gap-3 p-3">
                <ButtonV2 color="success" animation class="px-5" @click="applySetting">{{ t(TEXT.save) }}</ButtonV2>
            </div>
        </div>
    </Modal>
</template>